import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    wrapperGallery: {
      display: "flex",
      flexDirection: "column",
      gap: "32px",
    },
    containerPropretiesSection: {
      display: "flex",
      flexDirection: "column",
      gap: "24px",
    },
    containerLoacationSection: {
      display: "flex",
      flexDirection: "column",
      gap: "24px",
    },
    containerHeadersection: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        alignItems:'flex-start'
      },
    },
    containerTitles: {
      display: "flex",
      flexDirection: "column",
    },
    mainTitle: {
      fontSize: "18px",
      fontWeight: 600,
      color: theme.palette.text.primary,
      lineHeight: "28px",
    },
    subTitle: {
      fontSize: "18px",
      fontWeight: 400,
      color: theme.palette.text.tertiary,
      lineHeight: "28px",
    },
  };
});
